<template>
  <div>
        <v-sheet class="pb-2 sheet-header d-flex" min-height="48" dark :color="color">
          <v-container class="pt-1 pb-0 fluid" color="primary">
            <v-layout row wrap align-center justify-space-between>
              <slot>
              <v-flex class="d-inline-block header--title">
                <slot name="left"></slot>
              </v-flex>
              <v-flex class="text-md-right">
                <slot name="right"></slot>
              </v-flex>
              </slot>
            </v-layout>
          </v-container>
        </v-sheet>
  </div>
</template>

<script>
export default {
  props: {
    props: {
      type: Object,
      default: function () {
        return {}
      }
    },
    color: {type: String}
  }
}
</script>
<style>
.v-sheet.sheet-header {
  border-radius: 0px;
}
.header--title {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.02em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/utils/RespHeader.vue